import {
  FilterAllExcludeFilterEnum,
  FilterAllExcludeFilterLabels
} from '@/bundles/GroupFilters/enums/transactionType/FilterAllExcludeFilterEnum';

export const FilterSubleaseButtonItems = [
  {
    text: FilterAllExcludeFilterLabels[FilterAllExcludeFilterEnum.exclude],
    value: FilterAllExcludeFilterEnum.exclude,
    btnText: `Exclude \n Sublease`,
  },
  {
    text: FilterAllExcludeFilterLabels[FilterAllExcludeFilterEnum.all],
    value: FilterAllExcludeFilterEnum.all,
  },
  {
    text: FilterAllExcludeFilterLabels[FilterAllExcludeFilterEnum.filter],
    value: FilterAllExcludeFilterEnum.filter,
    btnText: `Sublease \n Only`,
  }
];
